/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerRevenueRankingFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CustomerRevenueRanking, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/customers/top-by-revenue
 */
export interface TopByRevenueRequestBuilder extends BaseRequestBuilder<TopByRevenueRequestBuilder> {
    /**
     * Ranks customers by the order totals they placed in the period, highest first. Rows are grouped on the customer number and company name recorded on each order, so a customer whose company name changed part-way through the window appears once under each name; add the rows up by customer number if you need one figure. The name is the snapshot from the order rather than the customer record as it stands now. averageOrderValue is that customer's own mean for the window, not their share of the organization's. Both date bounds are inclusive; a period with no orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerRevenueRanking[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<TopByRevenueRequestBuilderGetQueryParameters> | undefined) : Promise<CustomerRevenueRanking[] | undefined>;
    /**
     * Ranks customers by the order totals they placed in the period, highest first. Rows are grouped on the customer number and company name recorded on each order, so a customer whose company name changed part-way through the window appears once under each name; add the rows up by customer number if you need one figure. The name is the snapshot from the order rather than the customer record as it stands now. averageOrderValue is that customer's own mean for the window, not their share of the organization's. Both date bounds are inclusive; a period with no orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TopByRevenueRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Ranks customers by the order totals they placed in the period, highest first. Rows are grouped on the customer number and company name recorded on each order, so a customer whose company name changed part-way through the window appears once under each name; add the rows up by customer number if you need one figure. The name is the snapshot from the order rather than the customer record as it stands now. averageOrderValue is that customer's own mean for the window, not their share of the organization's. Both date bounds are inclusive; a period with no orders returns an empty array.
 */
export interface TopByRevenueRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * How many rows to return, taken from the top of the ranking. Defaults to 10; there is nopaging, so raise this rather than trying to page past the cut-off.
     */
    limit?: number;
    /**
     * Start of the period, inclusive. Compared against the order date as a full timestamp.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const TopByRevenueRequestBuilderUriTemplate = "{+baseurl}/api/analytics/customers/top-by-revenue?endDate={endDate}&limit={limit}&startDate={startDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TopByRevenueRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TopByRevenueRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCustomerRevenueRankingFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
